<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="学校名称" prop="commercial_id" v-if="autocompleteData.schoolsList.length > 0">
                <el-autocomplete
                    v-model="autocompleteData.school_name"
                    clearable
                    value-key="school_name"
                    placeholder="请输入"
                    :trigger-on-focus="false"
                    :fetch-suggestions="(query, cb) => querySchoolSearch(query, cb, 'schoolsList')"
                    @clear="clearSelect('schoolsList', 2)"
                    @select="(item)=>handleSelect(item, 'schoolsList')">
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="店铺名称" prop="shop_id" v-if="autocompleteData.shopsList.length > 0">
                <el-autocomplete
                    v-model="autocompleteData.shop_name"
                    clearable
                    value-key="shop_name"
                    placeholder="请输入"
                    :trigger-on-focus="false"
                    :fetch-suggestions="(query, cb) => querySchoolSearch(query, cb, 'shopsList')"
                    @clear="clearSelect('shopsList', 2)"
                    @select="(item)=>handleSelect(item, 'shopsList')">
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="配送类型" prop="orderType">
                <el-select v-model="queryForm.orderType" placeholder="请选择">
                    <el-option label="配送单" value="0"></el-option>
                    <el-option label="自提单" value="1"></el-option>
                    <el-option label="西游侠打赏订单" value="2"></el-option>
                    <el-option label="堂食" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下单日期" prop="dateType">
                <el-date-picker
                    class="fl ml10"
                    v-model="queryForm.dateRange"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    placeholder="请选择日期"
                    :picker-options="pickerOptions">
                    <!---->
                </el-date-picker>
            </el-form-item>
            <el-form-item label="支付方式" prop="payway">
                <el-select v-model="queryForm.payway" placeholder="请选择">
                    <el-option
                        v-for="item in payWayList"
                        :key="item.value"
                        :label="item.desc"
                        :value="item.value"
                    ></el-option>
                    <!--<el-option label="配送单" value="0"></el-option>-->
                    <!--<el-option label="自提单" value="1"></el-option>-->
                    <!--<el-option label="西游侠打赏订单" value="2"></el-option>-->
                    <!--<el-option label="堂食" value="3"></el-option>-->
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetch">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20">
          <el-button size="mini" type="primary" @click="fetch('week')">周数据查询</el-button>
          <el-button size="mini" type="primary" @click="fetch('month')">月数据查询</el-button>
        </el-row>
        <!--<div class="red pb10">说明：此报表未扣除退款订单金额</div>-->
        <el-card class="box-card mb20" style="background-color: #eaf5fc">
            <el-row>
                <el-col :span="5">
                    <div>订单总数</div>
                    <p class="red f12"><span class="f20 plr2">{{ statisticsData.orderNumber }}</span></p>
                </el-col>
                <el-col :span="5">
                    <div>结算金额</div>
                    <p class="red f12"><span class="f20 plr2">{{ statisticsData.orderAmount }}</span>元</p>
                </el-col>
                <el-col :span="5">
                    <div>退款订单总数</div>
                    <p class="red f12"><span class="f20 plr2">{{ statisticsData.refundNumber }}</span></p>
                </el-col>
                <el-col :span="5">
                    <div>退款金额总计</div>
                    <p class="red f12"><span class="f20 plr2">{{ statisticsData.refundAmount }}</span>元</p>
                </el-col>
                <el-col :span="4">
                    <div>佣金总计</div>
                    <!--c1cb761-->
                    <p class="red f12"><span class="f20 plr2">{{ statisticsData.commission }}</span>元</p>
                </el-col>
            </el-row>
        </el-card>
        <el-row class="pb20">
            <el-button size="mini" type="primary" @click="bindExcl">导出excel</el-button>
        </el-row>
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                v-for="(item, index) in tableColumn"
                :prop="item.id"
                :label="item.name"
                :show-overflow-tooltip="true"
                :key="index"
                :width="item.width"
                :fixed="item.fixed">
                <template slot-scope="scope">
                    <span v-if="item.formatter">{{ item.formatter(scope.row) }}</span>
                    <span v-else>{{ scope.row[item.id] }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNo"
            :page-sizes="pageSizes"
            :page-size="queryForm.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import { getSchoolAndShop } from '~/mixins/getSchoolAndShop';
import ExportExcel from "../../../../components/exportExcel2.vue";
import moment from 'moment';
import store from "../../../../store";


export default {
    components: { ExportExcel },
    mixins: [ getSchoolAndShop, ],
    data() {
        let vue = this;
        return {
            token: '',
            timeOptionRange: null,
            pickerOptions: {
                disabledDate(time) {
                    let timeOptionRange = vue.timeOptionRange;
                    let secondNum = 30*24*60*60*1000;
                    if(timeOptionRange){
                        return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum ;
                    }
                },
                onPick(time){
                    //当第一时间选中才设置禁用
                    if(time.minDate && !time.maxDate){
                        vue.timeOptionRange = time.minDate;
                    }
                    if(time.maxDate){
                        vue.timeOptionRange = null;
                    }
                }
            },
            queryFormLabelWidth: '100px',//自定义查询表单label宽度
            payWayName: '',
            payWayList: [],
            queryForm: {//查询表单数据
                pageSize: 10,
                pageNo: 1,
                dateRange: [],
                payway: '', // 支付方式
                orderType: '', // 订单类型
            },
            total: 0,//总数
            pageSizes: [10,20,30,40,50],//自定义分页条数
            tableColumn: [
                { name: '学校名称', id: 'schoolName', fixed: false, }, //  width: '120'
                { name: '门店名称', id: 'shopName', fixed: false, }, //  width: '120'
                { name: '订单号', id: 'id', fixed: false, width: '120' },
                { name: '结算金额（元）', id: 'payCallback', fixed: false, width: '100' },
                { name: '佣金（元）', id: 'commission', fixed: false, width: '90' },
                { name: '佣金率', id: 'commissionRate', fixed: false, width: '90' },
                // { name: '商家活动补贴', id: 'shopSubsidy', fixed: false, width: '100' },
                // { name: '平台活动补贴', id: 'platformSubsidy', fixed: false, width: '100' },
                { name: '支付方式', id: 'payWay', fixed: false, width: '120' },
                { name: '下单时间', id: 'createTime', fixed: false, width: '150' },
                { name: '配送类型', id: 'orderType', fixed: false, width: '150' },
                {
                    name: '订单状态',
                    id: 'orderStatus',
                    fixed: false,
                    width: '150',
                    formatter: (row) => {
                        return row.orderStatus == 1000 ? '待付款' : row.orderStatus == 1001 ? '已支付(备餐中)' : row.orderStatus == 2001 ? '待领取' : row.orderStatus == 2002 ? '配送完成' : row.orderStatus == 3001 ? '确认收货(已完成)' : row.orderStatus == 9000 ? '已取消' : row.orderStatus == 8000 ? '错误' : '';
                    }
                },
            ],
            loading: false,
            tableData: [],
            statisticsData: {
                orderNumber: 0, //	订单数
                orderAmount: 0, //	订单总金额
                commission: 0, //	佣金金额
                refundNumber: 0, //	退款总数
                refundAmount: 0, //	退款金额
            },
        }
    },
    created(){
        //默认显示最近一周
        this.token = this.$store.getters.token;
        if(this.$route.query.date){
            let temp = [];
            temp = this.$route.query.date.split('-');
            this.queryForm.dateRange = [new Date(temp[0],temp[1]-1,temp[2]),new Date(temp[1],temp[1]-1,temp[2])];
        }else{
            let day = new Date();
            day.setTime(day.getTime()-1*24*60*60*1000);
            this.queryForm.dateRange = [day,new Date()];
        }
        this.autocompleteData.isGoods = false;
        this.getPayWay();
        this.getStatistics();
    },
    mounted() {
        this.getStatistics();
        this.fetchData();
    },
    methods: {
        /** 导出excel */
        bindExcl() {
            let params = {
              token: this.token,
              payWay: this.queryForm.payway, // 支付方式
              pageSize: this.queryForm.pageSize,
              orderType: this.queryForm.orderType == '' ? '' : Number(this.queryForm.orderType), //	订单类型
              pageNo: this.queryForm.pageNo,
              schoolCode: this.autocompleteData.school_id, // 学校名称
              shopCode: this.autocompleteData.shop_id, // 门店名称
              beforeDate: moment(this.queryForm.dateRange[0]).format('YYYY-MM-DD'), // 起始时间
              afterDate: moment(this.queryForm.dateRange[1]).format('YYYY-MM-DD'), // 结束时间
            };
            // let url = 'https://oc.anlaiye.com.cn/private/report/count/order/detail';
            // let url = 'http://oc.imcoming.com/private/report/count/order/detail';
            let url;
            if (window.location.host.indexOf('anlaiye') >= 0) {
              url = 'https://oc.anlaiye.com.cn/private/report/count/order/detail';
            } else {
              url = 'http://oc.imcoming.com/private/report/count/order/detail';
            }
            let paramsStr = "?";
            for(let k in params) {
              paramsStr += (k + "=" + params[k] + "&");
            }
            paramsStr = paramsStr.slice(0, -1);
            // window.open(url + paramsStr);
            this.$api.open(this.$apiUrl.commercialGdReportOrderDetail2, params);
        },
        /** 切换每页显示条数操作 */
        handleSizeChange(val) {
            this.queryForm.pageNo = 1;
            this.queryForm.pageSize = val;
            this.fetchData();
        },
        /** 切换页码操作 */
        handleCurrentChange(val) {
            this.queryForm.pageNo = val;
            this.fetchData();
        },
        /** 重置 */
        resetForm () {
            let day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.dateRange = [day,new Date()];
            this.queryForm.pageNo = 1;
            this.queryForm.pageSize = 10;
            this.queryForm.orderType = '';
            this.queryForm.payway = '';
            this.autocompleteData.school_id = '';
            this.autocompleteData.shop_id = '';
            this.getStatistics();
            this.fetchData();
        },
        /** 支付方式相关 */
        // fetchPayWay (query, cb) {
        //     this.querySchoolSearch(query, cb, 'payWayList', this.payWayList)
        // },
        /** 获取支付方式列表 */
        getPayWay () {
            this.$apiJava.get(this.$apiUrl.commercialGdOrderPayWay, {},(res)=>{
                if (res.message == "success" && res.result && res.data) {
                    this.payWayList = res.data;
                  console.log(res)
                } else {
                    this.payWayList = [];
                    this.$message.warning(res.message);
                }
            },(res)=>{
                this.payWayList = [];
                this.$message.warning(res.message);
            },'oc')
        },
        /** 获取订单汇总数据 */
        getStatistics () {
            let params = {
                payWay: this.queryForm.payway, // 支付方式
                orderType: this.queryForm.orderType == '' ? '' : Number(this.queryForm.orderType), //	订单类型
                schoolCode: this.autocompleteData.school_id, // 学校名称
                shopCode: this.autocompleteData.shop_id, // 门店名称
                beforeDate: moment(this.queryForm.dateRange[0]).format('YYYY-MM-DD'),
                afterDate: moment(this.queryForm.dateRange[1]).format('YYYY-MM-DD'),
            }
            this.$apiJava.post(this.$apiUrl.commercialGdStatistics, params,(res)=>{
                if (res.message == "success" && res.result && res.data) {
                    for(let k in this.statisticsData) {
                        if (res.data[k] >= 0) this.statisticsData[k] = res.data[k];
                    }
                } else {
                    for(let k in this.statisticsData) {
                        this.statisticsData[k] = 0;
                    }
                    this.$message.warning(res.message);
                }
            },(res)=>{
                for(let k in this.statisticsData) {
                    this.statisticsData[k] = 0;
                }
                this.$message.warning(res.message);
            },'gc')
        },
        tableCount (params) {
            // let params = {
            //     schoolCode: this.autocompleteData.school_id, // 学校名称
            //     shopCode: this.autocompleteData.shop_id, // 门店名称
            //     beforeDate: moment(this.queryForm.dateRange[0]).format('YYYY-MM-DD'),
            //     afterDate: moment(this.queryForm.dateRange[1]).format('YYYY-MM-DD'),
            // }
            this.$apiJava.post(this.$apiUrl.commercialGdCountOrderDetail, params,(res)=>{
                if (res.message == "success" && res.result && res.data) {
                    this.total = res.data.total;
                } else {
                    this.total = 0;
                    this.$message.warning(res.message);
                }
            },(res)=>{
                this.total = 0;
                this.$message.warning(res.message);
            },'gc')
        },
        /** 获取订单列表 */
        fetchData () {
            let before = moment(this.queryForm.dateRange[0]).format('YYYY-MM-DD');
            let after = moment(this.queryForm.dateRange[1]).format('YYYY-MM-DD');

            if (new Date(after).getTime() - new Date(before).getTime() > (1000 * 60 * 60 * 24 * 31)) {
              before = new Date(new Date(after).getTime() - (1000 * 60 * 60 * 24 * 31));
              before = moment(before).format('YYYY-MM-DD');
            }
            let params = {
                payWay: this.queryForm.payway, // 支付方式
                pageSize: this.queryForm.pageSize,
                orderType: this.queryForm.orderType == '' ? '' : Number(this.queryForm.orderType), //	订单类型
                pageNo: this.queryForm.pageNo,
                schoolCode: this.autocompleteData.school_id, // 学校名称
                shopCode: this.autocompleteData.shop_id, // 门店名称
                beforeDate: before, // 起始时间
                afterDate: after, // 结束时间
            };
            console.log(params)
            this.tableCount({
                payWay: this.queryForm.payway, // 支付方式
                orderType: this.queryForm.orderType == '' ? '' : Number(this.queryForm.orderType), //	订单类型
                schoolCode: this.autocompleteData.school_id, // 学校名称
                shopCode: this.autocompleteData.shop_id, // 门店名称
                beforeDate: before,
                afterDate: after,
            })
            this.$apiJava.post(this.$apiUrl.commercialGdOrderDetail, params,(res)=>{
                if (res.message == "success" && res.result && res.data) {
                    // this.total = res.data.total;
                    this.tableData = res.data.orderDetails;
                } else {
                    // this.total = 0;
                    this.tableData = [];
                    this.$message.warning(res.message);
                }
            },(res)=>{
                // this.total = 0;
                this.tableData = [];
                this.$message.warning(res.message);
            },'gc')
        },
        fetch (type) {
            if (type == 'week') {
                let day = new Date();
                day.setTime(day.getTime()-6*24*60*60*1000);
                this.queryForm.dateRange = [day,new Date()];
            } else if (type == 'month') {
                let day = new Date();
                day.setTime(day.getTime()-30*24*60*60*1000);
                this.queryForm.dateRange = [day,new Date()];
            }
            this.queryForm.pageNo = 1;
            this.getStatistics();
            this.fetchData();
        }
    }
}
</script>
<style lang="scss"  scoped>
  .el-card{
      /*border: none;*/
      /*box-shadow: none;*/
  }
</style>


// WEBPACK FOOTER //
// list.vue?76932a0c